var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.06732 38.2497L0.333984 34.5163L15.2673 19.583L0.333984 4.64967L4.06732 0.916336L19.0007 15.8497L33.934 0.916336L37.6673 4.64967L22.734 19.583L37.6673 34.5163L33.934 38.2497L19.0007 23.3163L4.06732 38.2497Z",
    fill: "#FF9800"
  })));
}

export default __webpack_public_path__ + "media/2fb3baac.svg";
export { SvgCross as ReactComponent };